// Routes.js
import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import {
  Home,
  Login,
  Forgot,
  Reset,
  Register,
  Prices,
  FAQ,
  About,
  Services,
  Clients,
  Help,
  PrivacyPolicy,
  TermsOfService,
  CookiePolicy,
  ContactUs,
  Download,
  Checkout,
  UserGroups,
  AddUserGroup,
  NotificationsList,
  ClientLogin,
  ClientPortalHome,
  ClientProfile,
  ProfileSettings,
  ChangePassword,
  MySubscription,
  MyBilling,
  MySubscriptions,
  OwnedCompanies,
  DomainManagement,
  MyInvoices,
  MyOrders,
  MyTasks,
  MyDocuments,
  MyKnowledge,
  MyBackupRestore,
  MySupportTickets,
} from "./lazyComponents";

export default function Routes() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        {/* Public Routes */}
        <Route path="/:lang?/" exact component={Home} />
        <Route path="/login" exact component={Login} />
        <Route path="/:lang/login" exact component={Login} />
        <Route
          path="/:lang/app/main"
          exact
          render={({ match }) => (
            <Redirect to={`/${match.params.lang}/my-account`} />
          )}
        />
        <Route
          path="/:lang/app/accounting"
          exact
          render={({ match }) => (
            <Redirect to={`/${match.params.lang}/my-account`} />
          )}
        />
        <Route path="/:lang/forgot" exact component={Forgot} />
        <Route path="/:lang/forgot-password" exact component={Forgot} />
        <Route path="/:lang/reset/:token" exact component={Reset} />
        <Route path="/:lang/prices" exact component={Prices} />
        <Route path="/:lang/faq" exact component={FAQ} />
        <Route path="/:lang/about" exact component={About} />
        <Route path="/:lang/services" exact component={Services} />
        <Route path="/:lang/clients" exact component={Clients} />
        <Route path="/:lang/help" exact component={Help} />
        <Route path="/privacy-policy" exact component={PrivacyPolicy} />
        <Route path="/:lang/privacy-policy" exact component={PrivacyPolicy} />
        <Route path="/terms-of-service" exact component={TermsOfService} />
        <Route path="/:lang/terms-of-service" exact component={TermsOfService} />
        <Route path="/cookie-policy" exact component={CookiePolicy} />
        <Route path="/:lang/cookie-policy" exact component={CookiePolicy} />
        <Route path="/:lang/contactus" exact component={ContactUs} />
        <Route path="/:lang/download" exact component={Download} />
        <Route path="/:lang/signup" exact component={Register} />
        <Route path="/:lang/profile" exact component={ProfileSettings} />
        <Route path="/:lang/change-password" exact component={ChangePassword} />
        <Route path="/:lang/checkout" exact component={Checkout} />
        <Route path="/:lang/my-account" exact component={MySubscription} />
        <Route path="/:lang/my-billing" exact component={MyBilling} />
        <Route path="/:lang/my-subscriptions" exact component={MySubscriptions} />
        <Route path="/:lang/owned-companies" exact component={OwnedCompanies} />
        <Route path="/:lang/my-invoices" exact component={MyInvoices} />
        <Route path="/:lang/my-orders" exact component={MyOrders} />
        <Route path="/:lang/my-tasks" exact component={MyTasks} />
        <Route path="/:lang/my-documents" exact component={MyDocuments} />
        <Route path="/:lang/my-knowledge" exact component={MyKnowledge} />
        <Route path="/:lang/my-support-tickets" exact component={MySupportTickets} />
        <Route
          path="/:lang/backup-and-restore"
          exact
          component={MyBackupRestore}
        />
        <Route
          path="/:lang/domains-and-subdomains"
          exact
          component={DomainManagement}
        />
        {/* Client Portal Routes */}
        <Route path="/:lang/client-login" exact component={ClientLogin} />
        <Route
          path="/:lang/client-portal/home"
          exact
          component={ClientPortalHome}
        />
        <Route
          path="/:lang/client-portal/profile"
          exact
          component={ClientProfile}
        />
        {/* App Routes */}
        <Route
          path="/:lang/app/notifications"
          exact
          component={NotificationsList}
        />
        <Route
          path="/:lang/app/my-subscription"
          exact
          component={MySubscription}
        />
        <Route path="/:lang/app/add/group/" exact component={AddUserGroup} />
        <Route
          path="/:lang/app/edit/group/:id"
          exact
          component={AddUserGroup}
        />
        <Route path="/:lang/app/groups" exact component={UserGroups} />
      </Switch>
    </Suspense>
  );
}
